import Phaser from 'phaser'

export default class ScrapDisplay {
  private text: Phaser.GameObjects.Text
  private scrapAmount: number = 0

  constructor(scene: Phaser.Scene, initialScrap: number = 0) {
    this.scrapAmount = initialScrap
    const displayText = `SCRAP: ${this.scrapAmount}`
    
    this.text = scene.add
      .text(scene.cameras.main.width - 20, 16, displayText, {
        fontSize: '24px',
        color: '#ff6b6b',
        fontFamily: 'Arial, sans-serif',
        fontStyle: 'bold',
      })
      .setOrigin(1, 0)
      .setScrollFactor(0)
      .setDepth(1000)
  }

  addScrap(amount: number): void {
    this.scrapAmount += amount
    this.update()
  }

  subtractScrap(amount: number): boolean {
    if (this.scrapAmount < amount) {
      return false
    }
    this.scrapAmount -= amount
    this.update()
    return true
  }

  getScrap(): number {
    return this.scrapAmount
  }

  private update(): void {
    const color = this.scrapAmount > 0 ? '#ff6b6b' : '#ff0000'
    this.text.setText(`SCRAP: ${this.scrapAmount}`)
    this.text.setColor(color)
  }

  destroy(): void {
    this.text.destroy()
  }
}
